/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {SearchPageComponent} from './search-page.component';


export function searchStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.search', {
          url: '/search?q&types&labels&exclusionLabels&matchingLabels&objectState&rateControlLabels',
          reloadOnSearch: false,
          views: {
            content: {
              component: SearchPageComponent
            },
            title: stateTitleView()
          },
          data: {
            title: 'Search Results'
          }
        });
  }, adnRouterHelper);
}
